import React from 'react'
import cn from 'classnames'

import { useDropdown } from '@hooks/useDropdown'
import { ChevronDownIcon } from '@components/icons/ChevronDownIcon'
import { SelectPerPageProps } from './interface'

const SelectPerPage = ({
  options,
  value,
  className,
  handleSelect,
  dataTest,
}: SelectPerPageProps) => {
  const { dropdownRef, isShowDropdown, toggleDropdown } = useDropdown()

  return (
    <div
      data-test={`per-page-${dataTest}`}
      className={cn('relative w-[200px]', className)}
      ref={dropdownRef}
    >
      <div
        data-test={dataTest}
        className={cn(
          'w-full h-[40px] border rounded-[8px] pt-[9px] pb-[11px] px-[10px] cursor-pointer flex items-center justify-between dark:bg-dark-8 dark:text-dark-10',
          {
            'border-primary text-primary dark:text-dark-10': isShowDropdown,
            'border-gray-3 text-secondary-1  dark:border-purple':
              !isShowDropdown,
          }
        )}
        onClick={toggleDropdown}
      >
        <div
          data-test={dataTest}
          className='flex space-x-[4px] text-[14px] font-light'
        >
          <span>แสดง :</span>
          <span
            className={cn('font-bold', {
              'text-primary': isShowDropdown,
              'text-secondary dark:text-dark-10': !isShowDropdown,
            })}
          >
            {value}
          </span>
          <span>รายการต่อหน้า</span>
        </div>
        <ChevronDownIcon width='16' height='16' className='text-primary' />
      </div>
      <div
        className={cn(
          'absolute text-[14px] w-full z-10 mt-[15px] right-0 bg-white dark:bg-dark-8 shadow-dropdown border border-gray-4 dark:border-purple rounded-[10px] max-h-[400px] overflow-y-auto',
          { hidden: !isShowDropdown }
        )}
      >
        <div data-test='per-page-list' className='my-[10px]'>
          {options.map((row, index) => (
            <div
              data-test={`per-page-${row.value}-${dataTest}`}
              className='py-[6px] px-[15px] text-secondary dark:text-dark-10 hover:bg-primary-1 dark:hover:bg-dark hover:text-primary dark:hover:text-dark-10 cursor-pointer'
              key={index}
              onClick={() => {
                handleSelect(row.value)
                toggleDropdown()
              }}
            >
              <span className='font-light'>แสดง :</span>
              <span className={cn('font-bold mx-[5px]')}>{row.value}</span>
              <span className='font-light'>รายการต่อหน้า</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default SelectPerPage
